import { createRouter, createWebHistory } from 'vue-router'
import { useAuthAdminStore } from '@/stores/authAdminStore'
/* const HomeView = () => import('../views/HomeView.vue')
const InscriptionsView = () => import('../views/InscriptionsView.vue')
const TransfertInscriptionView = () => import('../views/TransfertInscriptionView.vue')
const ChoixReportView = () => import('../views/ChoixReportView.vue')
const ForgottenPasswordView = () => import('../views/ForgottenPasswordView.vue')
const ResetPasswordView = () => import('../views/ResetPasswordView.vue')
const CartView = () => import('../views/CartView.vue')
const CheckoutSuccessView = () => import('../views/CheckoutSuccess.vue')
const CheckoutAdminSuccessView = () => import('../views/CheckoutAdminSuccess.vue')
const CheckoutTransfertSuccessView = () => import('../views/CheckoutTransfertSuccess.vue')
const InscriptionsListView = () => import('../views/InscriptionsListView.vue')
const FicheCoureurView = () => import('../views/FicheCoureur/FicheCoureurView.vue')
const HistoriqueView = () => import('../views/FicheCoureur/HistoriqueView.vue')
const EditInscriptionView = () => import('../views/FicheCoureur/EditInscriptionView.vue')
const AddOptionsView = () => import('../views/FicheCoureur/AddOptionsView.vue')
const AddOptionsCartView = () => import('../views/FicheCoureur/AddOptionsCartView.vue')
const EditDocumentView = () => import('../views/FicheCoureur/EditDocumentView.vue')
const RequestTransfertInscriptionView = () => import('../views/FicheCoureur/RequestTransfertInscriptionView.vue')
const RequestBourseDossardInscriptionView = () => import('../views/FicheCoureur/RequestBourseDossardInscriptionView.vue')
const ChangerParcoursView = () => import('../views/FicheCoureur/ChangerParcoursView.vue')
const ChangerParcoursCartView = () => import('../views/FicheCoureur/ChangerParcoursCartView.vue')
const RefundGIAView = () => import("../views/FicheCoureur/RefundGIAView.vue")
const EditAlerteSMSContactsView = () => import("../views/FicheCoureur/EditAlerteSMSContactsView.vue")
const BourseDossardsView = () => import('../views/BourseDossardsView.vue')
const ListeAttenteBourseView = () => import('../views/ListeAttenteBourseView.vue')
const BuyDossardBourseView = () => import('../views/BuyDossardBourseView.vue')
const BuyDossardListeAttenteView = () => import('../views/BuyDossardListeAttenteView.vue')
const ValidationPreInscriptionsAdminView = () => import('../views/Administration/ValidationPreInscriptionsAdminView.vue')
const ListPreInscriptionsAdminView = () => import('../views/Administration/ListPreInscriptionsAdminView.vue')
const ChargePendingsCommandesView = () => import('../views/Administration/ChargePendingsCommandesView.vue')
const ListPreInscriptionsView = () => import('../views/PreinscriptionsListView.vue')
const VerifyInscriptionView = () => import('../views/VerifyInscriptionView.vue')
const MailingSystemView = () => import('../views/Administration/MailingSystem/DashboardView.vue')
const MailingCreateContactListingView = () => import('../views/Administration/MailingSystem/CreateContactListingView.vue')
const MailingCreateCampaignView = () => import('../views/Administration/MailingSystem/CreateCampaignView.vue')
const AdministrationView = () => import('../views/Administration/AdministrationView.vue')
const CodeReductionView = () => import('../views/Administration/CodeReductionView.vue')
const EnvoiRecapEmailView = () => import('../views/Administration/EnvoiRecapEmailView.vue')
const EnvoiRappelDocEmailView = () => import('../views/Administration/EnvoiRappelDocEmailView.vue')
const LienVIPView = () => import('../views/Administration/LienVIPView.vue')
const LienMultiVIPView = () => import('../views/Administration/LienMultiVIPView.vue')
const ExportListInscritsView = () => import('../views/Administration/ExportListInscritsView.vue')
const ExplorerSuperAdminView = () => import('../views/Administration/ExplorerSuperAdminView.vue')
const SearchRefundView = () => import('../views/Administration/SearchRefundView.vue')
const ListInscriptionsAdminView = () => import('../views/Administration/ListInscriptionsAdminView.vue')
const EditInscriptionAdminView = () => import('../views/Administration/EditInscriptionAdminView.vue')
const RefundCommandeView = () => import('../views/Administration/RefundCommandeView.vue')
const GestionAccesView = () => import('../views/Administration/GestionAccesView.vue')
const PaymentsRequestsView = () => import('../views/Administration/PaymentsRequestsView.vue')
const ConfigurationModuleAdminView = () => import('../views/Administration/ConfigurationModuleAdminView.vue')
const ValidationDocumentsAdminView = () => import('../views/Administration/ValidationDocumentsAdminView.vue')
const ListInscritsMultiParcoursView = () => import('../views/Administration/ListInscritsMultiParcoursView.vue')
const LienGroupeInscriptionView = () => import('../views/Administration/LienGroupeInscriptionView.vue')
const ListeAttenteBourseAdminView = () => import('../views/Administration/ListeAttenteBourseAdminView.vue')
const ResendPaymentView = () => import('../views/ResendPaymentView.vue')
const PaymentLinkView = () => import('../views/PaymentLinkView.vue') */


import HomeView from '../views/HomeView.vue'
import InscriptionsView from '../views/InscriptionsView.vue'
import TransfertInscriptionView from '../views/TransfertInscriptionView.vue'
import ChoixReportView from '../views/ChoixReportView.vue'
import ForgottenPasswordView from '../views/ForgottenPasswordView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import CartView from '../views/CartView.vue'
import CheckoutSuccessView from '../views/CheckoutSuccess.vue'
import CheckoutAdminSuccessView from '../views/CheckoutAdminSuccess.vue'
import CheckoutTransfertSuccessView from '../views/CheckoutTransfertSuccess.vue'

import InscriptionsListView from '../views/InscriptionsListView.vue'
import FicheCoureurView from '../views/FicheCoureur/FicheCoureurView.vue'
import HistoriqueView from '../views/FicheCoureur/HistoriqueView.vue'
import EditInscriptionView from '../views/FicheCoureur/EditInscriptionView.vue'
import AddOptionsView from '../views/FicheCoureur/AddOptionsView.vue'
import AddOptionsCartView from '../views/FicheCoureur/AddOptionsCartView.vue'
import EditDocumentView from '../views/FicheCoureur/EditDocumentView.vue'
import RequestTransfertInscriptionView from '../views/FicheCoureur/RequestTransfertInscriptionView.vue'
import RequestBourseDossardInscriptionView from '../views/FicheCoureur/RequestBourseDossardInscriptionView.vue'
import ChangerParcoursView from '../views/FicheCoureur/ChangerParcoursView.vue'
import ChangerParcoursCartView from '../views/FicheCoureur/ChangerParcoursCartView.vue'
import RefundGIAView from "../views/FicheCoureur/RefundGIAView.vue"
import EditAlerteSMSContactsView from "../views/FicheCoureur/EditAlerteSMSContactsView.vue"


import AdministrationView from "../views/Administration/AdministrationView.vue"
import CodeReductionView from "../views/Administration/CodeReductionView.vue"
import EnvoiRecapEmailView from "../views/Administration/EnvoiRecapEmailView.vue"
import EnvoiRappelDocEmailView from "../views/Administration/EnvoiRappelDocEmailView.vue"
import EnvoiRappelContactSMSView from "../views/Administration/EnvoiRappelContactSMSView.vue"
import LienVIPView from "../views/Administration/LienVIPView.vue"
import LienMultiVIPView from "../views/Administration/LienMultiVIPView.vue"
import ExportListInscritsView from "../views/Administration/ExportListInscritsView.vue"
import ExplorerSuperAdminView from "../views/Administration/ExplorerSuperAdminView.vue"
import SearchRefundView from "../views/Administration/SearchRefundView.vue"
import ListInscriptionsAdminView from "../views/Administration/ListInscriptionsAdminView.vue"
import EditInscriptionAdminView from "../views/Administration/EditInscriptionAdminView.vue"
import RefundCommandeView from "../views/Administration/RefundCommandeView.vue"
import GestionAccesView from "../views/Administration/GestionAccesView.vue"
import PaymentsRequestsView from "../views/Administration/PaymentsRequestsView.vue"
import ConfigurationModuleAdminView from "../views/Administration/ConfigurationModuleAdminView.vue"
import ValidationDocumentsAdminView from "../views/Administration/ValidationDocumentsAdminView.vue"
import ValidationJustificatifVagueAdminView from "../views/Administration/ValidationJustificatifVagueAdminView.vue"
import ListInscritsMultiParcoursView from "../views/Administration/ListInscritsMultiParcoursView.vue"
import ExportEquipesNFL26AdminView from "../views/Administration/ExportEquipesNFL26AdminView.vue"
import GestionEquipesAdminView from "../views/Administration/GestionEquipesAdminView.vue"
import LienGroupeInscriptionView from "../views/Administration/LienGroupeInscriptionView.vue"
import EditLienGroupeView from "../views/Administration/EditLienGroupeView.vue"
import ListeAttenteBourseAdminView from "../views/Administration/ListeAttenteBourseAdminView.vue"
import PodiumsPreviewView from "../views/Administration/PodiumsPreviewView.vue"
import ResendPaymentView from "../views/ResendPaymentView.vue"
import PaymentLinkView from "../views/PaymentLinkView.vue"
import SuiviLienGroupeView from "../views/SuiviLienGroupeView.vue"
import BourseDossardsView from "../views/BourseDossardsView.vue"
import ListeAttenteBourseView from "../views/ListeAttenteBourseView.vue"
import BuyDossardBourseView from "../views/BuyDossardBourseView.vue"
import BuyDossardListeAttenteView from "../views/BuyDossardListeAttenteView.vue"
import ValidationPreInscriptionsAdminView from "../views/Administration/ValidationPreInscriptionsAdminView.vue"
import ListPreInscriptionsAdminView from "../views/Administration/ListPreInscriptionsAdminView.vue"
import ChargePendingsCommandesView from "../views/Administration/ChargePendingsCommandesView.vue"
import ListPreInscriptionsView from "../views/PreinscriptionsListView.vue"
import VerifyInscriptionView from "../views/VerifyInscriptionView.vue"
import MailingSystemView from "../views/Administration/MailingSystem/DashboardView.vue"
import MailingCreateContactListingView from "../views/Administration/MailingSystem/CreateContactListingView.vue"
import MailingCreateCampaignView from "../views/Administration/MailingSystem/CreateCampaignView.vue"
import BulkRefundsView from "../views/Administration/BulkRefundsView.vue"
import RetraitDossardView from "../views/Administration/RetraitDossardView.vue"
import LCE26PerformanceView from "../views/Customs/LCE26PerformanceView.vue"
import DashboardConfigurationView from "../views/Administration/AdminDashboardConfigurationView.vue"
import RecapPlanEntrainementView from "../views/RecapPlanEntrainementView.vue"


const routes = [
  {
    path: '/:base_module', // Permet de récuperer le paramètre :id_evenement dans l'url, qui sera accessible dans le composant
    name: 'Home',
    component: HomeView,
  },

  {
    path: '/:base_module/admin',
    name: 'Administration',
    component: AdministrationView
  },
  {
    path: '/:base_module/admin/configuration',
    name: 'ConfigurationModuleAdmin',
    component: ConfigurationModuleAdminView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/validation_documents',
    name: 'ValidationDocumentsAdmin',
    component: ValidationDocumentsAdminView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/validation-justificatif-vague',
    name: 'ValidationJustificatifVagueAdmin',
    component: ValidationJustificatifVagueAdminView,
    meta: { requiresAdminAuth: true }
  },

  {
    path: '/:base_module/admin/lien_privilegie',
    name: 'LienVIP',
    component: LienVIPView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/lien_groupe_inscription',
    name: 'LienGroupeInscription',
    component: LienGroupeInscriptionView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/lien_groupe_inscription/:token/modifier',
    name: 'EditLienGroupe',
    component: EditLienGroupeView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/lien_privilegie_multi',
    name: 'LienMultiVIP',
    component: LienMultiVIPView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/liste-inscrits-multi-parcours',
    name: 'ListInscritsMultiParcours',
    component: ListInscritsMultiParcoursView,
    meta: {
      requiresAdminAuth: true
    }
  },
  {
    path: '/:base_module/admin/export-equipes-nfl26',
    name: 'ExportEquipesNFL26Admin',
    component: ExportEquipesNFL26AdminView,
    meta: {
      requiresAdminAuth: true
    }
  },
  {
    path: '/:base_module/admin/gestion-equipes',
    name: 'GestionEquipesAdmin',
    component: GestionEquipesAdminView,
    meta: {
      requiresAdminAuth: true,
      requiresSportipsAdmin: true
    }
  },
  {
    path: '/:base_module/admin/liste-preinscrits',
    name: 'ListPreInscriptionsAdmin',
    component: ListPreInscriptionsAdminView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/validation-preinscrits',
    name: 'ValidationPreInscriptionsAdmin',
    component: ValidationPreInscriptionsAdminView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/liste-attente-bourse',
    name: 'ListeAttenteBourseAdmin',
    component: ListeAttenteBourseAdminView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/charge-pendings-commandes',
    name: 'ChargePendingsCommandes',
    component: ChargePendingsCommandesView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/verifier-inscription',
    name: 'VerifyInscription',
    component: VerifyInscriptionView,

  },
  {
    path: '/:base_module/suivi-lien-groupe/:token',
    name: 'SuiviLienGroupe',
    component: SuiviLienGroupeView,
  },
  {
    path: '/:base_module/admin/export_inscrits',
    name: 'ExportListInscrits',
    component: ExportListInscritsView,
    meta: { requiresAdminAuth: true }
  },


  {
    path: '/:base_module/admin/gestion_acces',
    name: 'GestionAcces',
    component: GestionAccesView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/payments-requests',
    name: 'PaymentsRequests',
    component: PaymentsRequestsView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/code_reduction',
    name: 'CodeReduction',
    component: CodeReductionView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/podiums-preview',
    name: 'PodiumsPreview',
    component: PodiumsPreviewView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/explorer',
    name: 'ExplorerSuperAdmin',
    component: ExplorerSuperAdminView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/send-recap-email',
    name: 'EnvoiRecapEmail',
    component: EnvoiRecapEmailView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/send-rappel-doc-email',
    name: 'EnvoiRappelDocEmail',
    component: EnvoiRappelDocEmailView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/send-rappel-contact-sms',
    name: 'EnvoiRappelContactSMS',
    component: EnvoiRappelContactSMSView,
    meta: { requiresAdminAuth: true }
  },

  {
    path: '/:base_module/admin/search-refund',
    name: 'SearchRefund',
    component: SearchRefundView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/liste-inscrits',
    name: 'ListInscriptionsAdmin',
    component: ListInscriptionsAdminView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/bulk-refunds',
    name: 'BulkRefunds',
    component: BulkRefundsView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/dashboard-configuration',
    name: 'DashboardConfiguration',
    component: DashboardConfigurationView,
    meta: { requiresAdminAuth: true }
  },

  {
    path: '/:base_module/admin/edit/:id_inscription',
    name: 'EditInscriptionAdmin',
    component: EditInscriptionAdminView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/admin/refund/:id_commande',
    name: 'RefundCommande',
    component: RefundCommandeView,
    meta: { requiresAdminAuth: true }
  },

  {
    path: '/:base_module/admin/mailing-system',
    name: 'MailingSystem',
    component: MailingSystemView,
    meta: { requiresAdminAuth: true }
  },

  {
    path: '/:base_module/admin/mailing-system/create-contact-listing',
    name: 'MailingCreateContactListing',
    component: MailingCreateContactListingView,
    meta: { requiresAdminAuth: true }
  },

  {
    path: '/:base_module/admin/mailing-system/create-campaign',
    name: 'MailingCreateCampaign',
    component: MailingCreateCampaignView,
    meta: { requiresAdminAuth: true }
  },

  {
    path: '/:base_module/admin/mailing-system/create-campaign',
    name: 'MailingCreateCampaign',
    component: MailingCreateCampaignView,
    meta: { requiresAdminAuth: true }
  },

  {
    path: '/:base_module/admin/retrait-dossard',
    name: 'RetraitDossard',
    component: RetraitDossardView,
    meta: { requiresAdminAuth: true }
  },
  {
    path: '/:base_module/forgotten-password',
    name: 'ForgottenPassword',
    component: ForgottenPasswordView
  },
  {
    path: '/:base_module/reset-pass',
    name: 'ResetPassword',
    component: ResetPasswordView
  },
  {
    path: '/:base_module/inscription',
    name: 'Inscriptions',
    component: InscriptionsView
  },
  {
    path: '/:base_module/transfert',
    name: 'TransfertInscription',
    component: TransfertInscriptionView
  },
  {
    path: '/:base_module/choix-report',
    name: 'ChoixReport',
    component: ChoixReportView
  },
  {
    path: '/:base_module/cart',
    name: 'Cart',
    component: CartView
  },
  {
    path: '/:base_module/resend-payment',
    name: 'ResendPayment',
    component: ResendPaymentView
  },
  {
    path: '/:base_module/demande_paiement',
    name: 'PaymentLink',
    component: PaymentLinkView
  },

  {
    path: '/:base_module/checkout-success',
    name: 'CheckoutSuccess',
    component: CheckoutSuccessView
  },
  {
    path: '/:base_module/checkout-admin-success',
    name: 'CheckoutAdminSuccess',
    component: CheckoutAdminSuccessView
  },
  {
    path: '/:base_module/transfert-success',
    name: 'CheckoutTransfertSuccess',
    component: CheckoutTransfertSuccessView
  },


  {
    path: '/:base_module/liste-inscrits',
    name: 'InscriptionsList',
    component: InscriptionsListView
  },

  {
    path: '/:base_module/liste-preinscrits',
    name: 'ListPreInscriptions',
    component: ListPreInscriptionsView
  },

  {
    path: '/:base_module/fiche',
    name: 'FicheCoureur',
    component: FicheCoureurView
  },
  {
    path: '/:base_module/fiche/historique',
    name: 'Historique',
    component: HistoriqueView
  },
  {
    path: '/:base_module/fiche/edit/:id_inscription',
    name: 'EditInscription',
    component: EditInscriptionView
  },
  {
    path: '/:base_module/fiche/add-options/:id_commande',
    name: 'AddOptions',
    component: AddOptionsView
  },
  {
    path: '/:base_module/fiche/cart-add-options/:id_commande',
    name: 'AddOptionsCart',
    component: AddOptionsCartView
  },
  {
    path: '/:base_module/fiche/document/:id_inscription',
    name: 'EditDocument',
    component: EditDocumentView
  },
  {
    path: '/:base_module/fiche/transfert-inscription/:id_inscription',
    name: 'RequestTransfertInscription',
    component: RequestTransfertInscriptionView
  },
  {
    path: '/:base_module/fiche/request-bourse-dossard/:id_inscription',
    name: 'RequestBourseDossardInscription',
    component: RequestBourseDossardInscriptionView
  },
  {
    path: '/:base_module/fiche/changer-parcours/:id_commande_inscription',
    name: 'ChangerParcours',
    component: ChangerParcoursView
  },
  {
    path: '/:base_module/fiche/cart-changer-parcours/:id_commande_inscription',
    name: 'ChangerParcoursCart',
    component: ChangerParcoursCartView
  },
  {
    path: '/:base_module/fiche/remboursement-gia/:id_inscription',
    name: 'RefundGIA',
    component: RefundGIAView
  },
  {
    path: '/:base_module/fiche/edit-alerte-sms-contacts/:id_inscription',
    name: 'EditAlerteSMSContacts',
    component: EditAlerteSMSContactsView
  },
  {
    path: '/:base_module/bourse-dossards',
    name: 'BourseDossards',
    component: BourseDossardsView
  },
  {
    path: '/:base_module/liste-attente',
    name: 'ListeAttenteBourse',
    component: ListeAttenteBourseView
  },
  {
    path: '/:base_module/buy-dossard-liste-attente',
    name: 'BuyDossardListeAttente',
    component: BuyDossardListeAttenteView
  },
  {
    path: '/:base_module/buy-dossard-bourse/:id_dossard_bourse',
    name: 'BuyDossardBourse',
    component: BuyDossardBourseView
  },

  {
    path: '/:base_module/performance',
    name: 'LCE26Performance',
    component: LCE26PerformanceView
  },
  {
    path: '/:base_module/recap-plan-entrainement',
    name: 'RecapPlanEntrainement',
    component: RecapPlanEntrainementView
  }


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const authAdminStore = useAuthAdminStore()
  if (to.matched.some(record => record.meta.requiresAdminAuth)) {
    if (!authAdminStore.isLogged || !authAdminStore.hasModuleAccess) {
      next({
        name: 'Administration',
        params: { base_module: to.params.base_module }
      })
    } else if (to.matched.some(record => record.meta.requiresSportipsAdmin) && !authAdminStore.isSportipsAdmin) {
      next({
        name: 'Administration',
        params: { base_module: to.params.base_module }
      })
    } else {
      next()
    }
  } else {
    next()
  }
});

export default router
